module.exports = __webpack_public_path__ + "img/illustrator.2bf92dbf.png";